import { Component } from '@angular/core';

@Component({
  selector: 'app-whats-new',
  templateUrl: './whats-new.component.html',
  styleUrls: []
})
export class WhatsNewComponent {
}
